import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Kaliningrad as Desc } from './desk'
import { Kaliningrad as Mob } from './mob'

type Props = {
  images: TImages
}
export const Kaliningrad: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
